export const AUTOCOMPLETE_OFF = 'off'
export const NUMBER_FIELD_MIN = 1
export const NUMBER_FIELD_MAX = 1000000
export const NUMBER_FIELD_STEP = 1

export const TEXT_FIELD_AUTOCOMPLETE = {
  on: 'on',
  off: 'off',
}
